module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'col-' + _vm.documentSize,
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('div', [_c('div', {
    class: {
      focusedDoc: _vm.focusDoc
    },
    on: {
      "click": _vm.switchFocusDoc
    }
  }, [(_vm.documentType === 'pdf' && _vm.documentDataForPDF.data) ? _c('pdf', {
    ref: "pdf",
    attrs: {
      "src": _vm.documentDataForPDF,
      "page": _vm.page
    },
    on: {
      "progress": function($event) {
        _vm.loadedRatio = $event
      },
      "numPages": function($event) {
        _vm.numPages = $event
      }
    }
  }) : _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.src
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "inline-block",
      "text-align": "center",
      "width": "100%"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.page + '/' + _vm.numPages) + "\n    ")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-af21afac", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af21afac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/DocumentViewer.vue
// module id = 2432
// module chunks = 2